export default __webpack_public_path__ + "static/media/closeIcon.176b190a.svg";